import { Form } from 'react-router'
import { MaskedInput } from '~/components/MaskedInput'
import { Contact } from '~/components/Contact'
import { SubmitTrigger } from '~/components/SubmitTrigger'
import { FormErrorProvider } from '~/components/FormContext'
import { HEALTH_GATEWAY_URL } from '~/utils/constants'

export const VerificationForm = ({ errors }) => {
  const classNames = 'pt-0 mt-0'
  return (
    <>
      <div className="mb-4 pt-4 text-xl font-medium text-[#707276]">
        <p className="pb-4 text-2xl"> Verify your registration with your Personal Health Number.</p>
      </div>

      <div className="flex max-w-[710px] flex-col rounded-lg border-2 border-solid border-[#6FCF97] bg-[#fafafa]  drop-shadow-[4px_4px_4px_rgba(0,0,0,0.25)] ">
        <FormErrorProvider errors={errors}>
          <Form
            method="post"
            autoComplete="off"
            className="py-10 px-10 pb-5 xl:px-28"
          >
            <div className={classNames}>
              <div className="mb-3 flex flex-wrap items-start justify-end sm:justify-start">
                <MaskedInput
                  name="phn"
                  label="Personal Health Number"
                  placeholder="9--- --- ---"
                  options={{ blocks: [4, 3, 3] }}
                />
                <div className="mt-6">
                  <SubmitTrigger label="Verify >" />
                </div>
              </div>
            </div>
          </Form>
        </FormErrorProvider>
        <div className="bg-[#58b847] py-10 px-10 text-slate-100 xl:px-28">
          If you have questions about registering or changing your decision, <Contact showLink="false" />
        </div>
      </div>

      <div className="max-w-[710px]">
        <div className="pt-4 text-xl font-medium text-[#707276]">
          <p className="pb-4 text-2xl">Have a BC Services Card?</p>
        </div>
        <p className="pb-4">
          You can check your registration status and review your decision details in Health Gateway.
          Any new or updated registrations may take 2 hours to show in Health Gateway.
        </p>
        {/* eslint-disable-next-line */}
        <a href={HEALTH_GATEWAY_URL} target="_blank">
          <img
            src="/images/hg-logo.png"
            alt="Go to healthgateway home page"
            className="h-18 mt-2 mb-8 rounded-md bg-[#036] p-2"
          />
        </a>
      </div>
    </>
  )
}
